export const winterTireVehicles = ["cadillac-escalade-2023"];

export function hasWinterTires(slug: string) {
  return winterTireVehicles.includes(slug);
}

export function winterTireAnswer(slug: string) {
  return hasWinterTires(slug)
    ? "The Cadillac Escalade currently has winter tires. Check road conditions and posted tire requirements before travel; four-wheel drive does not replace suitable tires or safe driving."
    : "This vehicle does not currently have winter tires. Only our Cadillac Escalade currently has winter tires. For a winter Whistler trip, contact us before booking to confirm vehicle suitability and check posted tire requirements.";
}